import { render, staticRenderFns } from "./WebsiteDeleteScreen.vue?vue&type=template&id=e71c7680&scoped=true&lang=pug"
import script from "./WebsiteDeleteScreen.vue?vue&type=script&lang=ts"
export * from "./WebsiteDeleteScreen.vue?vue&type=script&lang=ts"
import style0 from "./WebsiteDeleteScreen.vue?vue&type=style&index=0&id=e71c7680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71c7680",
  null
  
)

export default component.exports